import Icon from '@/components/ui/AppIcon';

const GuaranteeSection = () => {
  const guarantees = [
    {
      icon: 'ShieldCheckIcon',
      title: '100% Satisfaction Guarantee',
      description: 'If you\'re not completely satisfied with our work, we\'ll make it right or provide a full refund.',
    },
    {
      icon: 'ClockIcon',
      title: 'On-Time Service Promise',
      description: 'We respect your time. If we\'re late, your service is discounted.',
    },
    {
      icon: 'SparklesIcon',
      title: 'Quality Workmanship',
      description: 'Professional-grade equipment and eco-friendly solutions for lasting results.',
    },
  ];

  return (
    <div className="bg-primary/5 rounded-lg p-8 border-2 border-primary">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-headline font-bold text-foreground mb-3">
          Our Service Guarantees
        </h2>
        <p className="text-muted-foreground font-body max-w-2xl mx-auto">
          We stand behind our work with industry-leading guarantees that protect your investment
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {guarantees.map((guarantee, index) => (
          <div key={index} className="text-center">
            <div className="w-16 h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center mx-auto mb-4">
              <Icon name={guarantee.icon as any} size={32} />
            </div>
            <h3 className="font-headline font-semibold text-lg text-foreground mb-2">
              {guarantee.title}
            </h3>
            <p className="text-sm text-muted-foreground font-body">
              {guarantee.description}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-8 pt-8 border-t border-primary/20 text-center">
        <p className="text-sm text-muted-foreground font-body">
          All services include a 30-day workmanship warranty. Licensed, bonded, and insured for your protection.
        </p>
      </div>
    </div>
  );
};

export default GuaranteeSection;